// client/src/flow/FlowBuilder.js
import React, { useState, useEffect } from "react";

import { CAPELANIA_EXAMPLE, SGPITS_EXAMPLE, UGITS_EXAMPLE, FLOW_EXAMPLES } from './examples';

import { useParams, useNavigate } from "react-router-dom";
import {
  Save,
  Eye,
  ArrowLeft,
  Plus,
  Trash2,
  Edit3,
  Move,
  Settings,
  Check,
  X,
  Copy,
  ChevronUp,
  ChevronDown,
  ChevronRight,
  ChevronLeft,
  Type,
  AlignLeft,
  List,
  Radio,
  CheckSquare,
  Calendar,
  Mail,
  Phone,
  Hash,
  FileText,
  Info,
  Zap,
  Image,
  Package,
  Layout,
  ExternalLink,
  Download,
  AlertCircle,
  User,
  Send,
  Home,
  Heart,
  Star,
  Sun,
  Moon,
  Book,
  Users,
  MessageCircle,
  Clock,
  MapPin,
  Shield,
  Award,
  Smile,
  Gift,
  Bell,
  Lock,
  Unlock,
  Search,
  Filter,
  RefreshCw,
  Activity,
  Anchor,
  Globe,
  Layers,
  Grid,
  Folder,
  FolderOpen,
  Database,
  HelpCircle,
  Circle,
  Square,
  Triangle,
  Hexagon,
  Octagon,
  Bookmark,
  Flag,
  Tag,
  Briefcase,
  Building,
  Coffee,
  Cpu,
  CreditCard,
  DollarSign,
  Feather,
  Film,
  Headphones,
  Key,
  Laptop,
  Link2,
  Music,
  Paperclip,
  Printer,
  Rocket,
  ShoppingCart,
  Tablet,
  Target,
  Tv,
  Umbrella,
  Video,
  Wifi,
  Wind,
  Zap as Lightning,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  Upload,
  Camera,
  Palette,
  Navigation 
} from "lucide-react";
import config from "./config";
import { uploadFlowLogo, deleteFlowLogo } from "./utils/supabase";
import "./FlowBuilder.css";

// Ícones disponíveis organizados por categoria
const AVAILABLE_ICONS = [
  // Religiosos/Espirituais
  { value: 'Heart', label: '❤️ Coração', icon: Heart, category: 'Religioso' },
  { value: 'Star', label: '⭐ Estrela', icon: Star, category: 'Religioso' },
  { value: 'Sun', label: '☀️ Sol', icon: Sun, category: 'Religioso' },
  { value: 'Moon', label: '🌙 Lua', icon: Moon, category: 'Religioso' },
  { value: 'Book', label: '📖 Livro Sagrado', icon: Book, category: 'Religioso' },
  { value: 'Users', label: '👥 Comunidade', icon: Users, category: 'Religioso' },
  { value: 'Home', label: '⛪ Igreja/Templo', icon: Home, category: 'Religioso' },
  { value: 'Shield', label: '🛡️ Proteção', icon: Shield, category: 'Religioso' },
  { value: 'Award', label: '🏆 Bênção', icon: Award, category: 'Religioso' },
  { value: 'Gift', label: '🎁 Oferenda', icon: Gift, category: 'Religioso' },
  
  // Comunicação
  { value: 'Mail', label: '📧 Email', icon: Mail, category: 'Comunicação' },
  { value: 'Phone', label: '📞 Telefone', icon: Phone, category: 'Comunicação' },
  { value: 'MessageCircle', label: '💬 Mensagem', icon: MessageCircle, category: 'Comunicação' },
  { value: 'Send', label: '📤 Enviar', icon: Send, category: 'Comunicação' },
  { value: 'Bell', label: '🔔 Notificação', icon: Bell, category: 'Comunicação' },
  
  // Interface/Ações
  { value: 'Check', label: '✅ Confirmar', icon: Check, category: 'Ação' },
  { value: 'X', label: '❌ Cancelar', icon: X, category: 'Ação' },
  { value: 'Plus', label: '➕ Adicionar', icon: Plus, category: 'Ação' },
  { value: 'Edit3', label: '✏️ Editar', icon: Edit3, category: 'Ação' },
  { value: 'Trash2', label: '🗑️ Excluir', icon: Trash2, category: 'Ação' },
  { value: 'Save', label: '💾 Salvar', icon: Save, category: 'Ação' },
  { value: 'Download', label: '⬇️ Baixar', icon: Download, category: 'Ação' },
  { value: 'Copy', label: '📋 Copiar', icon: Copy, category: 'Ação' },
  { value: 'Search', label: '🔍 Buscar', icon: Search, category: 'Ação' },
  { value: 'RefreshCw', label: '🔄 Atualizar', icon: RefreshCw, category: 'Ação' },
  
  // Navegação
  { value: 'ChevronRight', label: '➡️ Próximo', icon: ChevronRight, category: 'Navegação' },
  { value: 'ChevronLeft', label: '⬅️ Voltar', icon: ChevronLeft, category: 'Navegação' },
  { value: 'ChevronUp', label: '⬆️ Subir', icon: ChevronUp, category: 'Navegação' },
  { value: 'ChevronDown', label: '⬇️ Descer', icon: ChevronDown, category: 'Navegação' },
  { value: 'ArrowLeft', label: '← Esquerda', icon: ArrowLeft, category: 'Navegação' },
  { value: 'ArrowRight', label: '→ Direita', icon: ArrowRight, category: 'Navegação' },
  
  // Informação
  { value: 'Info', label: 'ℹ️ Informação', icon: Info, category: 'Info' },
  { value: 'AlertCircle', label: '⚠️ Alerta', icon: AlertCircle, category: 'Info' },
  { value: 'HelpCircle', label: '❓ Ajuda', icon: HelpCircle, category: 'Info' },
  { value: 'FileText', label: '📄 Documento', icon: FileText, category: 'Info' },
  { value: 'Folder', label: '📁 Pasta', icon: Folder, category: 'Info' },
  
  // Tempo
  { value: 'Calendar', label: '📅 Calendário', icon: Calendar, category: 'Tempo' },
  { value: 'Clock', label: '🕐 Relógio', icon: Clock, category: 'Tempo' },
  
  // Pessoas
  { value: 'User', label: '👤 Usuário', icon: User, category: 'Pessoas' },
  { value: 'Users', label: '👥 Grupo', icon: Users, category: 'Pessoas' },
  { value: 'Smile', label: '😊 Sorriso', icon: Smile, category: 'Pessoas' },
  
  // Lugares
  { value: 'MapPin', label: '📍 Local', icon: MapPin, category: 'Lugares' },
  { value: 'Globe', label: '🌍 Global', icon: Globe, category: 'Lugares' },
  { value: 'Building', label: '🏢 Prédio', icon: Building, category: 'Lugares' },
  
  // Objetos
  { value: 'Lock', label: '🔒 Cadeado', icon: Lock, category: 'Objetos' },
  { value: 'Key', label: '🔑 Chave', icon: Key, category: 'Objetos' },
  { value: 'Flag', label: '🚩 Bandeira', icon: Flag, category: 'Objetos' },
  { value: 'Tag', label: '🏷️ Etiqueta', icon: Tag, category: 'Objetos' },
  { value: 'Bookmark', label: '🔖 Marcador', icon: Bookmark, category: 'Objetos' },
  
  // Formas
  { value: 'Circle', label: '⭕ Círculo', icon: Circle, category: 'Formas' },
  { value: 'Square', label: '⬜ Quadrado', icon: Square, category: 'Formas' },
  { value: 'Triangle', label: '🔺 Triângulo', icon: Triangle, category: 'Formas' },
  
  // Outros
  { value: 'Zap', label: '⚡ Raio', icon: Lightning, category: 'Outros' },
  { value: 'Activity', label: '📊 Atividade', icon: Activity, category: 'Outros' },
  { value: 'Target', label: '🎯 Alvo', icon: Target, category: 'Outros' },
  { value: 'Layers', label: '📚 Camadas', icon: Layers, category: 'Outros' }
];

// Tipos de campos disponíveis
const FIELD_TYPES = [
  { type: 'text', label: 'Texto', icon: Type, description: 'Campo de texto simples' },
  { type: 'textarea', label: 'Texto Longo', icon: AlignLeft, description: 'Área de texto expandida' },
  { type: 'select', label: 'Dropdown', icon: List, description: 'Lista de opções' },
  { type: 'radio', label: 'Escolha Única', icon: Radio, description: 'Botões de opção' },
  { type: 'checkbox', label: 'Múltipla Escolha', icon: CheckSquare, description: 'Caixas de seleção' },
  { type: 'button', label: 'Botões', icon: Package, description: 'Botões de ação' },
  { type: 'date', label: 'Data', icon: Calendar, description: 'Seletor de data' },
  { type: 'email', label: 'Email', icon: Mail, description: 'Campo de email' },
  { type: 'phone', label: 'Telefone', icon: Phone, description: 'Campo de telefone' },
  { type: 'number', label: 'Número', icon: Hash, description: 'Campo numérico' },
  { type: 'section', label: 'Seção', icon: Layout, description: 'Divisor de seção' },
  { type: 'info', label: 'Informação', icon: Info, description: 'Bloco de informação' },
  { type: 'conditional', label: 'Condicional', icon: Zap, description: 'Campo condicional' }
];

// Helper function para calcular cor hover
const calculateHoverColor = (color, amount = -20) => {
  // Remove # se existir
  color = color.replace('#', '');
  
  // Converte para RGB
  const r = parseInt(color.substring(0, 2), 16);
  const g = parseInt(color.substring(2, 4), 16);
  const b = parseInt(color.substring(4, 6), 16);
  
  // Ajusta brilho
  const newR = Math.max(0, Math.min(255, r + amount));
  const newG = Math.max(0, Math.min(255, g + amount));
  const newB = Math.max(0, Math.min(255, b + amount));
  
  // Converte de volta para hex
  return `#${((1 << 24) + (newR << 16) + (newG << 8) + newB).toString(16).slice(1)}`;
};

const FlowBuilder = () => {

  const [showExamplesMenu, setShowExamplesMenu] = useState(false);

  const { id } = useParams();
  const navigate = useNavigate();
  const isNew = id === "new";

  const [flow, setFlow] = useState({
    name: "",
    url: "",
    type: "form",
    logo: null,
    formConfig: {
      title: "",
      subtitle: "",
      urgentPhone: "",
      email: "",
      successMessage: "Formulário enviado com sucesso!",
      steps: [],
      settings: {
        showProgressBar: true,
        requireConfirmation: true,
        generateProtocol: true,
        sendEmail: false,
        emailRecipients: []
      }
    },
    theme: {
      // Cores principais
      primaryColor: "#3498db",
      primaryColorHover: null,
      secondaryColor: "#ecf0f1",
      secondaryColorHover: null,
      
      // Backgrounds
      pageBackground: "#f5f7fa",
      cardBackground: "#ffffff",
      inputBackground: "#ffffff",
      
      // Textos
      textPrimary: "#333333",
      textSecondary: "#666666",
      textOnPrimary: "#ffffff",
      textOnSecondary: "#333333",
      
      // Bordas
      borderColor: "#dddddd",
      borderRadius: "8px",
      
      // Estados
      errorColor: "#e74c3c",
      successColor: "#27ae60",
      warningColor: "#f39c12",
      infoColor: "#3498db",
      
      // Botões
      buttonStyle: "rounded",
      buttonPadding: "12px 24px",
      buttonFontWeight: "600",
      
      // Fontes
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      fontSize: "14px",
      headingFontFamily: null,
      headingFontWeight: "600",
      
      // Sombras
      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
      boxShadowHover: "0 4px 12px rgba(0,0,0,0.1)",
      
      // Animações
      transitionDuration: "0.2s",
      
      // Outros
      progressBarColor: null,
      progressBarBackground: "#e0e0e0",
      logoBackground: "transparent",
      logoPadding: "0",
      logoBorderRadius: "0"
    }
  });

  const [selectedStep, setSelectedStep] = useState(null);
  const [selectedField, setSelectedField] = useState(null);
  const [activeTab, setActiveTab] = useState('steps'); // steps, settings, theme
  const [saving, setSaving] = useState(false);
  const [saveStatus, setSaveStatus] = useState("");
  const [showIconPicker, setShowIconPicker] = useState(null);
  const [iconSearch, setIconSearch] = useState("");
  const [showFieldIconPicker, setShowFieldIconPicker] = useState(null);
  const [fieldIconSearch, setFieldIconSearch] = useState("");
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [logoPreview, setLogoPreview] = useState(null);
  const [showThemePreview, setShowThemePreview] = useState(true);

  useEffect(() => {
    if (!isNew) {
      loadFlow();
    }
  }, [id]);

  // Fechar dropdown de ícones ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showIconPicker && !event.target.closest('.icon-selector')) {
        setShowIconPicker(null);
        setIconSearch('');
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [showIconPicker]);

  const loadFlow = async () => {
    try {
      const response = await fetch(`${config.serverUrl}/api/flows/edit/${id}`);
      if (response.ok) {
        const data = await response.json();
        setFlow(data);
        if (data.logo) {
          setLogoPreview(data.logo);
        }
        if (data.formConfig.steps && data.formConfig.steps.length > 0) {
          setSelectedStep(data.formConfig.steps[0].id);
        }
      } else {
        alert("Flow não encontrado");
        navigate("/flow");
      }
    } catch (error) {
      console.error("Erro ao carregar flow:", error);
    }
  };

  const loadCapelaniExample = () => {
    if (window.confirm("Isso irá substituir todo o conteúdo atual. Deseja continuar?")) {
      setFlow({
        ...flow,
        ...CAPELANIA_EXAMPLE,
        formConfig: {
          ...flow.formConfig,
          ...CAPELANIA_EXAMPLE.formConfig
        },
        theme: CAPELANIA_EXAMPLE.theme
      });
      if (CAPELANIA_EXAMPLE.formConfig.steps.length > 0) {
        setSelectedStep(CAPELANIA_EXAMPLE.formConfig.steps[0].id);
      }
    }
  };

  const loadSgpitsExample = () => {
    if (window.confirm("Isso irá substituir todo o conteúdo atual. Deseja continuar?")) {
      setFlow({
        ...flow,
        ...SGPITS_EXAMPLE,
        formConfig: {
          ...flow.formConfig,
          ...SGPITS_EXAMPLE.formConfig
        },
        theme: SGPITS_EXAMPLE.theme
      });
      if (SGPITS_EXAMPLE.formConfig.steps.length > 0) {
        setSelectedStep(SGPITS_EXAMPLE.formConfig.steps[0].id);
      }
    }
  };

  const loadUgitsExample = () => {
    if (window.confirm("Isso irá substituir todo o conteúdo atual. Deseja continuar?")) {
      setFlow({
        ...flow,
        ...UGITS_EXAMPLE,
        formConfig: {
          ...flow.formConfig,
          ...UGITS_EXAMPLE.formConfig
        },
        theme: UGITS_EXAMPLE.theme
      });
      if (UGITS_EXAMPLE.formConfig.steps.length > 0) {
        setSelectedStep(UGITS_EXAMPLE.formConfig.steps[0].id);
      }
    }
  };

  // Função para lidar com upload de logo (com deleção da antiga se existir)
  const handleLogoUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Validar tipo de arquivo
    const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
    if (!validTypes.includes(file.type)) {
      alert('Por favor, selecione uma imagem válida (JPEG, PNG, GIF ou WebP)');
      return;
    }

    // Validar tamanho (máximo 2MB)
    if (file.size > 2 * 1024 * 1024) {
      alert('A imagem deve ter no máximo 2MB');
      return;
    }

    setUploadingLogo(true);

    try {
      // Deletar logo antiga do Supabase se existir
      if (flow.logo && flow.logo.includes('supabase')) {
        await deleteFlowLogo(flow.logo);
      }

      // Criar preview local primeiro
      const reader = new FileReader();
      reader.onload = (e) => {
        setLogoPreview(e.target.result);
      };
      reader.readAsDataURL(file);

      // Upload para Supabase
      const logoUrl = await uploadFlowLogo(file, flow._id || 'new');
      
      // Atualizar flow com nova logo
      setFlow({ ...flow, logo: logoUrl });
      setLogoPreview(logoUrl);
      
      console.log('Logo uploaded:', logoUrl);
    } catch (error) {
      console.error('Erro ao fazer upload:', error);
      alert('Erro ao fazer upload da logo. Tente novamente.');
      setLogoPreview(flow.logo); // Reverter para logo anterior
    } finally {
      setUploadingLogo(false);
    }
  };

  // Função para remover logo
  const handleRemoveLogo = async () => {
    if (!window.confirm('Tem certeza que deseja remover a logo?')) return;

    setUploadingLogo(true);

    try {
      // Se tiver uma logo no Supabase, deletar
      if (flow.logo && flow.logo.includes('supabase')) {
        await deleteFlowLogo(flow.logo);
      }

      // Limpar logo do flow
      setFlow({ ...flow, logo: null });
      setLogoPreview(null);
    } catch (error) {
      console.error('Erro ao remover logo:', error);
      alert('Erro ao remover logo. Tente novamente.');
    } finally {
      setUploadingLogo(false);
    }
  };

  const saveFlow = async () => {
    if (!flow.name || !flow.url) {
      alert("Por favor, preencha o nome e URL do flow");
      return;
    }

    setSaving(true);
    setSaveStatus("");

    try {
      const url = isNew
        ? `${config.serverUrl}/api/flows`
        : `${config.serverUrl}/api/flows/${id}`;

      const response = await fetch(url, {
        method: isNew ? "POST" : "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(flow),
      });

      const data = await response.json();

      if (response.ok) {
        setSaveStatus("success");
        setTimeout(() => setSaveStatus(""), 3000);

        if (isNew && data.flow) {
          navigate(`/flow/builder/${data.flow._id}`, { replace: true });
        }
      } else {
        throw new Error(data.error || "Erro ao salvar");
      }
    } catch (error) {
      console.error("Erro ao salvar:", error);
      setSaveStatus("error");
      alert("Erro ao salvar flow: " + error.message);
    } finally {
      setSaving(false);
    }
  };

  // Funções para gerenciar steps
  const addStep = () => {
    const newStep = {
      id: `step-${Date.now()}`,
      title: "Nova Etapa",
      description: "",
      icon: "FileText",
      fields: [],
      navigation: {
        showPrevious: true,
        previousButtonText: "Voltar"
      },
      order: flow.formConfig.steps.length
    };

    setFlow({
      ...flow,
      formConfig: {
        ...flow.formConfig,
        steps: [...flow.formConfig.steps, newStep]
      }
    });
    setSelectedStep(newStep.id);
  };

  const updateStep = (stepId, updates) => {
    setFlow({
      ...flow,
      formConfig: {
        ...flow.formConfig,
        steps: flow.formConfig.steps.map(step =>
          step.id === stepId ? { ...step, ...updates } : step
        )
      }
    });
  };

  const deleteStep = (stepId) => {
    if (window.confirm("Tem certeza que deseja excluir esta etapa?")) {
      setFlow({
        ...flow,
        formConfig: {
          ...flow.formConfig,
          steps: flow.formConfig.steps.filter(step => step.id !== stepId)
        }
      });
      if (selectedStep === stepId) {
        setSelectedStep(null);
      }
    }
  };

  const moveStep = (stepId, direction) => {
    const steps = [...flow.formConfig.steps];
    const index = steps.findIndex(s => s.id === stepId);
    
    if (direction === 'up' && index > 0) {
      [steps[index], steps[index - 1]] = [steps[index - 1], steps[index]];
    } else if (direction === 'down' && index < steps.length - 1) {
      [steps[index], steps[index + 1]] = [steps[index + 1], steps[index]];
    }

    // Atualizar order
    steps.forEach((step, i) => {
      step.order = i;
    });

    setFlow({
      ...flow,
      formConfig: {
        ...flow.formConfig,
        steps
      }
    });
  };

  // Funções para gerenciar fields
  const addField = (stepId, fieldType) => {
    const step = flow.formConfig.steps.find(s => s.id === stepId);
    if (!step) return;

    const newField = {
      id: `field-${Date.now()}`,
      type: fieldType,
      label: `Novo ${FIELD_TYPES.find(f => f.type === fieldType)?.label}`,
      placeholder: "",
      description: "",
      required: false,
      options: fieldType === 'select' || fieldType === 'radio' || fieldType === 'checkbox' || fieldType === 'button' 
        ? [{ value: "opcao1", label: "Opção 1" }] 
        : [],
      validation: {},
      conditional: {
        show: false,
        when: "",
        equals: ""
      },
      style: {
        width: "full",
        variant: "default"
      },
      order: step.fields.length
    };

    updateStep(stepId, {
      fields: [...step.fields, newField]
    });

    setSelectedField(newField.id);
  };

  const updateField = (stepId, fieldId, updates) => {
    const step = flow.formConfig.steps.find(s => s.id === stepId);
    if (!step) return;

    updateStep(stepId, {
      fields: step.fields.map(field =>
        field.id === fieldId ? { ...field, ...updates } : field
      )
    });
  };

  const deleteField = (stepId, fieldId) => {
    if (window.confirm("Tem certeza que deseja excluir este campo?")) {
      const step = flow.formConfig.steps.find(s => s.id === stepId);
      if (!step) return;

      updateStep(stepId, {
        fields: step.fields.filter(field => field.id !== fieldId)
      });

      if (selectedField === fieldId) {
        setSelectedField(null);
      }
    }
  };

  const moveField = (stepId, fieldId, direction) => {
    const step = flow.formConfig.steps.find(s => s.id === stepId);
    if (!step) return;

    const fields = [...step.fields];
    const index = fields.findIndex(f => f.id === fieldId);
    
    if (direction === 'up' && index > 0) {
      [fields[index], fields[index - 1]] = [fields[index - 1], fields[index]];
    } else if (direction === 'down' && index < fields.length - 1) {
      [fields[index], fields[index + 1]] = [fields[index + 1], fields[index]];
    }

    // Atualizar order
    fields.forEach((field, i) => {
      field.order = i;
    });

    updateStep(stepId, { fields });
  };

  // Adicionar/remover opção
  const addOption = (stepId, fieldId) => {
    const step = flow.formConfig.steps.find(s => s.id === stepId);
    const field = step?.fields.find(f => f.id === fieldId);
    if (!field) return;

    const newOption = {
      value: `opcao${(field.options?.length || 0) + 1}`,
      label: `Opção ${(field.options?.length || 0) + 1}`,
      icon: "",
      description: ""
    };

    updateField(stepId, fieldId, {
      options: [...(field.options || []), newOption]
    });
  };

  const updateOption = (stepId, fieldId, optionIndex, updates) => {
    const step = flow.formConfig.steps.find(s => s.id === stepId);
    const field = step?.fields.find(f => f.id === fieldId);
    if (!field) return;

    const options = [...(field.options || [])];
    options[optionIndex] = { ...options[optionIndex], ...updates };

    updateField(stepId, fieldId, { options });
  };

  const removeOption = (stepId, fieldId, optionIndex) => {
    const step = flow.formConfig.steps.find(s => s.id === stepId);
    const field = step?.fields.find(f => f.id === fieldId);
    if (!field) return;

    updateField(stepId, fieldId, {
      options: field.options.filter((_, i) => i !== optionIndex)
    });
  };

  // Renderizar ícone
  const renderIcon = (iconName, size = 20) => {
    if (!iconName) return null;
    const IconComponent = AVAILABLE_ICONS.find(i => i.value === iconName)?.icon;
    return IconComponent ? <IconComponent size={size} /> : null;
  };

  // Atualizar o tema
  const updateTheme = (themeUpdates) => {
    const newTheme = { ...flow.theme, ...themeUpdates };
    
    // Auto-calcular cores hover se não estiverem definidas
    if (themeUpdates.primaryColor && !themeUpdates.primaryColorHover) {
      newTheme.primaryColorHover = calculateHoverColor(themeUpdates.primaryColor);
    }
    if (themeUpdates.secondaryColor && !themeUpdates.secondaryColorHover) {
      newTheme.secondaryColorHover = calculateHoverColor(themeUpdates.secondaryColor);
    }
    
    setFlow({ ...flow, theme: newTheme });
  };

  return (
    <div className="builder-container">
      {/* Header */}
      <div className="builder-header">
        <div className="header-left">
          <button onClick={() => navigate("/flow")} className="btn-back">
            <ArrowLeft size={20} />
            Voltar
          </button>
          <h1>{isNew ? "Novo Flow" : "Editar Flow"}</h1>
        </div>

        <div className="header-actions">
          {saveStatus === "success" && (
            <span className="save-status success">
              <Check size={16} />
              Salvo!
            </span>
          )}

          <div className="examples-dropdown">
            <button
              onClick={() => setShowExamplesMenu(!showExamplesMenu)}
              className="btn btn-secondary"
            >
              <Download size={20} />
              Carregar Exemplo
              <ChevronDown size={16} />
            </button>
            
            {showExamplesMenu && (
              <div className="examples-menu">
                <button
                  onClick={() => {
                    loadCapelaniExample();
                    setShowExamplesMenu(false);
                  }}
                  className="example-item"
                >
                  <FileText size={16} />
                  <div>
                    <strong>Capelania</strong>
                    <small>Formulário de visita religiosa</small>
                  </div>
                </button>
                
                <button
                  onClick={() => {
                    loadSgpitsExample();
                    setShowExamplesMenu(false);
                  }}
                  className="example-item"
                >
                  <Navigation size={16} />
                  <div>
                    <strong>SGPITS</strong>
                    <small>Sistema de navegação em árvore</small>
                  </div>
                </button>

                <button
                  onClick={() => {
                    loadUgitsExample();
                    setShowExamplesMenu(false);
                  }}
                  className="example-item"
                >
                  <Zap size={16} />
                  <div>
                    <strong>UGITS</strong>
                    <small>Portal de inovação tecnológica</small>
                  </div>
                </button>
              </div>
            )}
          </div>

          <button
            onClick={saveFlow}
            className="btn btn-primary"
            disabled={saving}
          >
            <Save size={20} />
            {saving ? "Salvando..." : "Salvar"}
          </button>

          {!isNew && (
            <button 
              onClick={() => window.open(`/${flow.url}`, "_blank")} 
              className="btn btn-secondary"
            >
              <Eye size={20} />
              Visualizar
            </button>
          )}
        </div>
      </div>

      <div className="builder-body">
        {/* Sidebar Esquerda - Configurações */}
        <div className={`builder-sidebar-left ${activeTab === 'settings' || activeTab === 'theme' ? 'wide' : ''}`}>
          <div className="sidebar-tabs">
            <button
              className={`tab-btn ${activeTab === 'steps' ? 'active' : ''}`}
              onClick={() => setActiveTab('steps')}
            >
              <Layout size={16} />
              Etapas
            </button>
            <button
              className={`tab-btn ${activeTab === 'settings' ? 'active' : ''}`}
              onClick={() => setActiveTab('settings')}
            >
              <Settings size={16} />
              Configurações
            </button>
            <button
              className={`tab-btn ${activeTab === 'theme' ? 'active' : ''}`}
              onClick={() => setActiveTab('theme')}
            >
              <Palette size={16} />
              Tema
            </button>
          </div>

          <div className="sidebar-content">
            {/* Tab: Etapas */}
            {activeTab === 'steps' && (
              <div className="steps-manager">
                <div className="section-header">
                  <h3>Etapas do Formulário</h3>
                  <button onClick={addStep} className="btn-icon">
                    <Plus size={16} />
                  </button>
                </div>

                <div className="steps-list">
                  {flow.formConfig.steps.sort((a, b) => a.order - b.order).map((step, index) => (
                    <div
                      key={step.id}
                      className={`step-item ${selectedStep === step.id ? 'active' : ''}`}
                      onClick={() => setSelectedStep(step.id)}
                    >
                      <div className="step-header">
                        <span className="step-number">{index + 1}</span>
                        <span className="step-title" translate="no">{step.title || 'Sem título'}</span>
                      </div>
                      <div className="step-actions">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            moveStep(step.id, 'up');
                          }}
                          disabled={index === 0}
                          className="btn-icon small"
                        >
                          <ChevronUp size={14} />
                        </button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            moveStep(step.id, 'down');
                          }}
                          disabled={index === flow.formConfig.steps.length - 1}
                          className="btn-icon small"
                        >
                          <ChevronDown size={14} />
                        </button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            deleteStep(step.id);
                          }}
                          className="btn-icon small danger"
                        >
                          <Trash2 size={14} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>

                {selectedStep && (
                  <div className="step-properties">
                    <h4>Propriedades da Etapa</h4>
                    {(() => {
                      const step = flow.formConfig.steps.find(s => s.id === selectedStep);
                      if (!step) return null;

                      return (
                        <>
                          <div className="form-group">
                            <label>Título</label>
                            <input
                              type="text"
                              value={step.title}
                              onChange={(e) => updateStep(selectedStep, { title: e.target.value })}
                              placeholder="Título da etapa"
                            />
                          </div>

                          <div className="form-group">
                            <label>Descrição</label>
                            <textarea
                              value={step.description}
                              onChange={(e) => updateStep(selectedStep, { description: e.target.value })}
                              placeholder="Descrição da etapa"
                              rows={2}
                            />
                          </div>

                          <div className="form-group">
                            <label>Ícone</label>
                            <div className="icon-selector">
                              <button
                                type="button"
                                className="icon-selector-trigger"
                                onClick={() => setShowIconPicker(showIconPicker === step.id ? null : step.id)}
                              >
                                {step.icon ? (
                                  <>
                                    {renderIcon(step.icon, 16)}
                                    <span>{AVAILABLE_ICONS.find(i => i.value === step.icon)?.label}</span>
                                  </>
                                ) : (
                                  <span>Selecione um ícone</span>
                                )}
                                <ChevronDown size={16} />
                              </button>
                              
                              {showIconPicker === step.id && (
                                <div className="icon-picker-dropdown">
                                  <div className="icon-picker-search">
                                    <input
                                      type="text"
                                      placeholder="Buscar ícone..."
                                      value={iconSearch}
                                      onChange={(e) => setIconSearch(e.target.value)}
                                    />
                                  </div>
                                  <div className="icon-picker-grid">
                                    {AVAILABLE_ICONS
                                      .filter(icon => 
                                        !iconSearch || 
                                        icon.label.toLowerCase().includes(iconSearch.toLowerCase()) ||
                                        icon.category.toLowerCase().includes(iconSearch.toLowerCase())
                                      )
                                      .map(icon => (
                                        <button
                                          key={icon.value}
                                          type="button"
                                          className={`icon-picker-item ${step.icon === icon.value ? 'selected' : ''}`}
                                          onClick={() => {
                                            updateStep(selectedStep, { icon: icon.value });
                                            setShowIconPicker(null);
                                            setIconSearch('');
                                          }}
                                          title={icon.label}
                                        >
                                          {renderIcon(icon.value, 20)}
                                        </button>
                                      ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="form-group">
                            <label>Texto do botão "Próximo"</label>
                            <input
                              type="text"
                              value={step.navigation?.nextButtonText || 'Continuar'}
                              onChange={(e) => updateStep(selectedStep, {
                                navigation: { ...step.navigation, nextButtonText: e.target.value }
                              })}
                            />
                          </div>

                          <div className="form-group">
                            <label>
                              <input
                                type="checkbox"
                                checked={step.navigation?.showPrevious !== false}
                                onChange={(e) => updateStep(selectedStep, {
                                  navigation: { ...step.navigation, showPrevious: e.target.checked }
                                })}
                              />
                              Mostrar botão "Voltar"
                            </label>
                          </div>
                        </>
                      );
                    })()}
                  </div>
                )}
              </div>
            )}

            {/* Tab: Configurações */}
            {activeTab === 'settings' && (
              <div className="settings-panel">
                <h3>Configurações do Formulário</h3>

                <div className="settings-panel-grid">
                  {/* Coluna Esquerda - Campos de texto */}
                  <div className="form-group">
                    <label>Nome do Flow</label>
                    <input
                      type="text"
                      value={flow.name}
                      onChange={(e) => setFlow({ ...flow, name: e.target.value })}
                      placeholder="Ex: Meu Formulário"
                    />
                  </div>

                  <div className="form-group" style={{ gridRow: '1 / span 5', gridColumn: '2' }}>
                    <label>Logo do Formulário</label>
                    <div className="logo-upload-section">
                      {logoPreview ? (
                        <div className="logo-preview">
                          <img 
                            src={logoPreview} 
                            alt="Logo preview" 
                            style={{
                              maxWidth: '100%',
                              maxHeight: '200px',
                              objectFit: 'contain',
                              marginBottom: '10px',
                              backgroundColor: flow.theme.logoBackground || 'transparent',
                              padding: flow.theme.logoPadding || '0',
                              borderRadius: flow.theme.logoBorderRadius || '0'
                            }}
                          />
                          <div style={{ marginTop: '10px', display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
                            <button
                              onClick={handleRemoveLogo}
                              className="btn btn-secondary"
                              disabled={uploadingLogo}
                            >
                              <Trash2 size={16} />
                              Remover Logo
                            </button>
                            <label className="btn btn-secondary" style={{ cursor: 'pointer' }}>
                              <input
                                type="file"
                                accept="image/*"
                                onChange={handleLogoUpload}
                                disabled={uploadingLogo}
                                style={{ display: 'none' }}
                              />
                              <Camera size={16} />
                              Alterar Logo
                            </label>
                          </div>
                        </div>
                      ) : (
                        <div className="logo-upload-empty">
                          <div style={{
                            border: '2px dashed #e0e0e0',
                            borderRadius: '8px',
                            padding: '40px 20px',
                            textAlign: 'center',
                            backgroundColor: '#f9f9f9',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: '300px'
                          }}>
                            <Upload size={48} style={{ color: '#ccc', marginBottom: '10px' }} />
                            <p style={{ color: '#666', marginBottom: '10px' }}>
                              Nenhuma logo adicionada
                            </p>
                            <label className="btn btn-primary" style={{ cursor: 'pointer' }}>
                              <input
                                type="file"
                                accept="image/*"
                                onChange={handleLogoUpload}
                                disabled={uploadingLogo}
                                style={{ display: 'none' }}
                              />
                              <Upload size={16} />
                              {uploadingLogo ? 'Enviando...' : 'Adicionar Logo'}
                            </label>
                            <p style={{ 
                              fontSize: '12px', 
                              color: '#999', 
                              marginTop: '10px',
                              marginBottom: '0'
                            }}>
                              Tamanho recomendado: 400x200px
                              <br />
                              Formatos: JPEG, PNG, GIF, WebP (máx. 2MB)
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <label>URL do Flow</label>
                    <div className="url-input-group">
                      <span className="url-prefix">{config.clientUrl}/</span>
                      <input
                        type="text"
                        value={flow.url}
                        onChange={(e) => setFlow({ ...flow, url: e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, '') })}
                        placeholder="meu-formulario"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Título do Formulário</label>
                    <input
                      type="text"
                      value={flow.formConfig.title}
                      onChange={(e) => setFlow({
                        ...flow,
                        formConfig: { ...flow.formConfig, title: e.target.value }
                      })}
                      placeholder="Título principal"
                    />
                  </div>

                  <div className="form-group">
                    <label>Subtítulo</label>
                    <textarea
                      value={flow.formConfig.subtitle}
                      onChange={(e) => setFlow({
                        ...flow,
                        formConfig: { ...flow.formConfig, subtitle: e.target.value }
                      })}
                      placeholder="Descrição do formulário"
                      rows={2}
                    />
                  </div>

                  <div className="form-group">
                    <label>Telefone de Contato</label>
                    <input
                      type="text"
                      value={flow.formConfig.urgentPhone}
                      onChange={(e) => setFlow({
                        ...flow,
                        formConfig: { ...flow.formConfig, urgentPhone: e.target.value }
                      })}
                      placeholder="(00) 0000-0000"
                    />
                  </div>

                  <div className="form-group">
                    <label>Email de Contato</label>
                    <input
                      type="email"
                      value={flow.formConfig.email}
                      onChange={(e) => setFlow({
                        ...flow,
                        formConfig: { ...flow.formConfig, email: e.target.value }
                      })}
                      placeholder="contato@exemplo.com"
                    />
                  </div>

                  <div className="form-group">
                    <label>Mensagem de Sucesso</label>
                    <textarea
                      value={flow.formConfig.successMessage}
                      onChange={(e) => setFlow({
                        ...flow,
                        formConfig: { ...flow.formConfig, successMessage: e.target.value }
                      })}
                      placeholder="Mensagem exibida após envio"
                      rows={2}
                    />
                  </div>

                  <div className="settings-toggles">
                    <label>
                      <input
                        type="checkbox"
                        checked={flow.formConfig.settings?.showProgressBar !== false}
                        onChange={(e) => setFlow({
                          ...flow,
                          formConfig: {
                            ...flow.formConfig,
                            settings: { ...flow.formConfig.settings, showProgressBar: e.target.checked }
                          }
                        })}
                      />
                      Mostrar barra de progresso
                    </label>

                    <label>
                      <input
                        type="checkbox"
                        checked={flow.formConfig.settings?.generateProtocol !== false}
                        onChange={(e) => setFlow({
                          ...flow,
                          formConfig: {
                            ...flow.formConfig,
                            settings: { ...flow.formConfig.settings, generateProtocol: e.target.checked }
                          }
                        })}
                      />
                      Gerar número de protocolo
                    </label>

                    <label>
                      <input
                        type="checkbox"
                        checked={flow.formConfig.settings?.sendEmail === true}
                        onChange={(e) => setFlow({
                          ...flow,
                          formConfig: {
                            ...flow.formConfig,
                            settings: { ...flow.formConfig.settings, sendEmail: e.target.checked }
                          }
                        })}
                      />
                      Enviar email ao submeter
                    </label>
                  </div>
                </div>
              </div>
            )}

            {/* Tab: Tema */}
            {activeTab === 'theme' && (
              <div className="theme-panel">
                <div className="section-header">
                  <h3>Personalização do Tema</h3>
                  <label style={{ fontSize: '14px', fontWeight: 'normal' }}>
                    <input
                      type="checkbox"
                      checked={showThemePreview}
                      onChange={(e) => setShowThemePreview(e.target.checked)}
                    />
                    Mostrar preview
                  </label>
                </div>

                {showThemePreview && (
                  <div className="theme-preview" style={{
                    marginBottom: '24px',
                    padding: '20px',
                    borderRadius: '8px',
                    backgroundColor: flow.theme.pageBackground,
                    border: '1px solid #e0e0e0'
                  }}>
                    <div style={{
                      backgroundColor: flow.theme.cardBackground,
                      padding: '20px',
                      borderRadius: flow.theme.borderRadius,
                      boxShadow: flow.theme.boxShadow,
                      fontFamily: flow.theme.fontFamily
                    }}>
                      <h4 style={{
                        color: flow.theme.textPrimary,
                        fontFamily: flow.theme.headingFontFamily || flow.theme.fontFamily,
                        fontWeight: flow.theme.headingFontWeight,
                        marginBottom: '12px'
                      }}>Preview do Formulário</h4>
                      
                      <p style={{
                        color: flow.theme.textSecondary,
                        fontSize: flow.theme.fontSize,
                        marginBottom: '16px'
                      }}>Este é um exemplo de como seu formulário aparecerá com as configurações atuais.</p>
                      
                      <input
                        type="text"
                        placeholder="Campo de exemplo"
                        style={{
                          width: '100%',
                          padding: '10px',
                          border: `1px solid ${flow.theme.borderColor}`,
                          borderRadius: flow.theme.borderRadius,
                          backgroundColor: flow.theme.inputBackground,
                          color: flow.theme.textPrimary,
                          fontSize: flow.theme.fontSize,
                          marginBottom: '12px'
                        }}
                      />
                      
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <button style={{
                          padding: flow.theme.buttonPadding,
                          backgroundColor: flow.theme.primaryColor,
                          color: flow.theme.textOnPrimary,
                          border: 'none',
                          borderRadius: flow.theme.borderRadius,
                          fontWeight: flow.theme.buttonFontWeight,
                          fontSize: flow.theme.fontSize,
                          cursor: 'pointer'
                        }}>Botão Primário</button>
                        
                        <button style={{
                          padding: flow.theme.buttonPadding,
                          backgroundColor: flow.theme.secondaryColor,
                          color: flow.theme.textOnSecondary,
                          border: 'none',
                          borderRadius: flow.theme.borderRadius,
                          fontWeight: flow.theme.buttonFontWeight,
                          fontSize: flow.theme.fontSize,
                          cursor: 'pointer'
                        }}>Botão Secundário</button>
                      </div>
                    </div>
                  </div>
                )}

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                  {/* Cores Principais */}
                  <div className="form-group">
                    <label>Cor Primária</label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <input
                        type="color"
                        value={flow.theme.primaryColor}
                        onChange={(e) => updateTheme({ primaryColor: e.target.value })}
                      />
                      <input
                        type="text"
                        value={flow.theme.primaryColor}
                        onChange={(e) => updateTheme({ primaryColor: e.target.value })}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Cor Primária (Hover)</label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <input
                        type="color"
                        value={flow.theme.primaryColorHover || calculateHoverColor(flow.theme.primaryColor)}
                        onChange={(e) => updateTheme({ primaryColorHover: e.target.value })}
                      />
                      <input
                        type="text"
                        value={flow.theme.primaryColorHover || calculateHoverColor(flow.theme.primaryColor)}
                        onChange={(e) => updateTheme({ primaryColorHover: e.target.value })}
                        style={{ flex: 1 }}
                        placeholder="Auto"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Cor Secundária</label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <input
                        type="color"
                        value={flow.theme.secondaryColor}
                        onChange={(e) => updateTheme({ secondaryColor: e.target.value })}
                      />
                      <input
                        type="text"
                        value={flow.theme.secondaryColor}
                        onChange={(e) => updateTheme({ secondaryColor: e.target.value })}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Cor Secundária (Hover)</label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <input
                        type="color"
                        value={flow.theme.secondaryColorHover || calculateHoverColor(flow.theme.secondaryColor)}
                        onChange={(e) => updateTheme({ secondaryColorHover: e.target.value })}
                      />
                      <input
                        type="text"
                        value={flow.theme.secondaryColorHover || calculateHoverColor(flow.theme.secondaryColor)}
                        onChange={(e) => updateTheme({ secondaryColorHover: e.target.value })}
                        style={{ flex: 1 }}
                        placeholder="Auto"
                      />
                    </div>
                  </div>

                  {/* Backgrounds */}
                  <div className="form-group">
                    <label>Fundo da Página</label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <input
                        type="color"
                        value={flow.theme.pageBackground}
                        onChange={(e) => updateTheme({ pageBackground: e.target.value })}
                      />
                      <input
                        type="text"
                        value={flow.theme.pageBackground}
                        onChange={(e) => updateTheme({ pageBackground: e.target.value })}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Fundo do Card</label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <input
                        type="color"
                        value={flow.theme.cardBackground}
                        onChange={(e) => updateTheme({ cardBackground: e.target.value })}
                      />
                      <input
                        type="text"
                        value={flow.theme.cardBackground}
                        onChange={(e) => updateTheme({ cardBackground: e.target.value })}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Fundo dos Inputs</label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <input
                        type="color"
                        value={flow.theme.inputBackground}
                        onChange={(e) => updateTheme({ inputBackground: e.target.value })}
                      />
                      <input
                        type="text"
                        value={flow.theme.inputBackground}
                        onChange={(e) => updateTheme({ inputBackground: e.target.value })}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </div>

                  {/* Textos */}
                  <div className="form-group">
                    <label>Texto Principal</label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <input
                        type="color"
                        value={flow.theme.textPrimary}
                        onChange={(e) => updateTheme({ textPrimary: e.target.value })}
                      />
                      <input
                        type="text"
                        value={flow.theme.textPrimary}
                        onChange={(e) => updateTheme({ textPrimary: e.target.value })}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Texto Secundário</label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <input
                        type="color"
                        value={flow.theme.textSecondary}
                        onChange={(e) => updateTheme({ textSecondary: e.target.value })}
                      />
                      <input
                        type="text"
                        value={flow.theme.textSecondary}
                        onChange={(e) => updateTheme({ textSecondary: e.target.value })}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Texto no Botão Primário</label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <input
                        type="color"
                        value={flow.theme.textOnPrimary}
                        onChange={(e) => updateTheme({ textOnPrimary: e.target.value })}
                      />
                      <input
                        type="text"
                        value={flow.theme.textOnPrimary}
                        onChange={(e) => updateTheme({ textOnPrimary: e.target.value })}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Texto no Botão Secundário</label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <input
                        type="color"
                        value={flow.theme.textOnSecondary}
                        onChange={(e) => updateTheme({ textOnSecondary: e.target.value })}
                      />
                      <input
                        type="text"
                        value={flow.theme.textOnSecondary}
                        onChange={(e) => updateTheme({ textOnSecondary: e.target.value })}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </div>

                  {/* Estados */}
                  <div className="form-group">
                    <label>Cor de Erro</label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <input
                        type="color"
                        value={flow.theme.errorColor}
                        onChange={(e) => updateTheme({ errorColor: e.target.value })}
                      />
                      <input
                        type="text"
                        value={flow.theme.errorColor}
                        onChange={(e) => updateTheme({ errorColor: e.target.value })}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Cor de Sucesso</label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <input
                        type="color"
                        value={flow.theme.successColor}
                        onChange={(e) => updateTheme({ successColor: e.target.value })}
                      />
                      <input
                        type="text"
                        value={flow.theme.successColor}
                        onChange={(e) => updateTheme({ successColor: e.target.value })}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Cor de Alerta</label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <input
                        type="color"
                        value={flow.theme.warningColor}
                        onChange={(e) => updateTheme({ warningColor: e.target.value })}
                      />
                      <input
                        type="text"
                        value={flow.theme.warningColor}
                        onChange={(e) => updateTheme({ warningColor: e.target.value })}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Cor de Informação</label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <input
                        type="color"
                        value={flow.theme.infoColor}
                        onChange={(e) => updateTheme({ infoColor: e.target.value })}
                      />
                      <input
                        type="text"
                        value={flow.theme.infoColor}
                        onChange={(e) => updateTheme({ infoColor: e.target.value })}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </div>

                  {/* Bordas */}
                  <div className="form-group">
                    <label>Cor da Borda</label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <input
                        type="color"
                        value={flow.theme.borderColor}
                        onChange={(e) => updateTheme({ borderColor: e.target.value })}
                      />
                      <input
                        type="text"
                        value={flow.theme.borderColor}
                        onChange={(e) => updateTheme({ borderColor: e.target.value })}
                        style={{ flex: 1 }}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Raio da Borda</label>
                    <select
                      value={flow.theme.borderRadius}
                      onChange={(e) => updateTheme({ borderRadius: e.target.value })}
                    >
                      <option value="0px">Sem borda</option>
                      <option value="4px">Pequeno</option>
                      <option value="8px">Médio</option>
                      <option value="12px">Grande</option>
                      <option value="16px">Extra grande</option>
                      <option value="24px">Arredondado</option>
                    </select>
                  </div>

                  {/* Fontes */}
                  <div className="form-group" style={{ gridColumn: '1 / -1' }}>
                    <label>Fonte Principal</label>
                    <select
                      value={flow.theme.fontFamily}
                      onChange={(e) => updateTheme({ fontFamily: e.target.value })}
                    >
                      <option value='-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'>Sistema (Padrão)</option>
                      <option value='"Arial", sans-serif'>Arial</option>
                      <option value='"Helvetica Neue", Helvetica, Arial, sans-serif'>Helvetica</option>
                      <option value='"Times New Roman", Times, serif'>Times New Roman</option>
                      <option value='Georgia, serif'>Georgia</option>
                      <option value='"Courier New", Courier, monospace'>Courier New</option>
                      <option value='Verdana, Geneva, sans-serif'>Verdana</option>
                      <option value='"Trebuchet MS", Helvetica, sans-serif'>Trebuchet MS</option>
                      <option value='"Lucida Sans", "Lucida Grande", sans-serif'>Lucida Sans</option>
                      <option value='Tahoma, Geneva, Verdana, sans-serif'>Tahoma</option>
                      <option value='"Palatino Linotype", "Book Antiqua", Palatino, serif'>Palatino</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Tamanho da Fonte</label>
                    <select
                      value={flow.theme.fontSize}
                      onChange={(e) => updateTheme({ fontSize: e.target.value })}
                    >
                      <option value="12px">Pequeno</option>
                      <option value="14px">Normal</option>
                      <option value="16px">Grande</option>
                      <option value="18px">Extra Grande</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Peso da Fonte (Títulos)</label>
                    <select
                      value={flow.theme.headingFontWeight}
                      onChange={(e) => updateTheme({ headingFontWeight: e.target.value })}
                    >
                      <option value="400">Normal</option>
                      <option value="500">Médio</option>
                      <option value="600">Semi-Bold</option>
                      <option value="700">Bold</option>
                      <option value="800">Extra Bold</option>
                    </select>
                  </div>

                  {/* Botões */}
                  <div className="form-group">
                    <label>Estilo dos Botões</label>
                    <select
                      value={flow.theme.buttonStyle}
                      onChange={(e) => updateTheme({ buttonStyle: e.target.value })}
                    >
                      <option value="rounded">Arredondado</option>
                      <option value="square">Quadrado</option>
                      <option value="pill">Pílula</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Espaçamento dos Botões</label>
                    <select
                      value={flow.theme.buttonPadding}
                      onChange={(e) => updateTheme({ buttonPadding: e.target.value })}
                    >
                      <option value="8px 16px">Pequeno</option>
                      <option value="10px 20px">Médio</option>
                      <option value="12px 24px">Grande</option>
                      <option value="14px 28px">Extra Grande</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Peso da Fonte (Botões)</label>
                    <select
                      value={flow.theme.buttonFontWeight}
                      onChange={(e) => updateTheme({ buttonFontWeight: e.target.value })}
                    >
                      <option value="400">Normal</option>
                      <option value="500">Médio</option>
                      <option value="600">Semi-Bold</option>
                      <option value="700">Bold</option>
                    </select>
                  </div>

                  {/* Sombras */}
                  <div className="form-group">
                    <label>Sombra</label>
                    <select
                      value={flow.theme.boxShadow}
                      onChange={(e) => updateTheme({ boxShadow: e.target.value })}
                    >
                      <option value="none">Sem sombra</option>
                      <option value="0 1px 3px rgba(0,0,0,0.12)">Suave</option>
                      <option value="0 2px 4px rgba(0,0,0,0.05)">Pequena</option>
                      <option value="0 4px 12px rgba(0,0,0,0.1)">Média</option>
                      <option value="0 8px 24px rgba(0,0,0,0.15)">Grande</option>
                    </select>
                  </div>

                  {/* Progress Bar */}
                  <div className="form-group">
                    <label>Cor da Barra de Progresso</label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <input
                        type="color"
                        value={flow.theme.progressBarColor || flow.theme.primaryColor}
                        onChange={(e) => updateTheme({ progressBarColor: e.target.value })}
                      />
                      <input
                        type="text"
                        value={flow.theme.progressBarColor || flow.theme.primaryColor}
                        onChange={(e) => updateTheme({ progressBarColor: e.target.value })}
                        style={{ flex: 1 }}
                        placeholder="Usa cor primária"
                      />
                    </div>
                  </div>

                  {/* Logo */}
                  <div className="form-group" style={{ gridColumn: '1 / -1' }}>
                    <h4 style={{ marginBottom: '12px' }}>Configurações da Logo</h4>
                  </div>

                  <div className="form-group">
                    <label>Fundo da Logo</label>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <input
                        type="color"
                        value={flow.theme.logoBackground === 'transparent' ? '#ffffff' : flow.theme.logoBackground}
                        onChange={(e) => updateTheme({ logoBackground: e.target.value })}
                      />
                      <input
                        type="text"
                        value={flow.theme.logoBackground}
                        onChange={(e) => updateTheme({ logoBackground: e.target.value })}
                        style={{ flex: 1 }}
                        placeholder="transparent"
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Espaçamento da Logo</label>
                    <select
                      value={flow.theme.logoPadding}
                      onChange={(e) => updateTheme({ logoPadding: e.target.value })}
                    >
                      <option value="0">Sem espaçamento</option>
                      <option value="8px">Pequeno</option>
                      <option value="16px">Médio</option>
                      <option value="24px">Grande</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Borda da Logo</label>
                    <select
                      value={flow.theme.logoBorderRadius}
                      onChange={(e) => updateTheme({ logoBorderRadius: e.target.value })}
                    >
                      <option value="0">Sem borda arredondada</option>
                      <option value="4px">Pequena</option>
                      <option value="8px">Média</option>
                      <option value="12px">Grande</option>
                      <option value="50%">Circular</option>
                    </select>
                  </div>

                  {/* Botão de Reset */}
                  <div style={{ gridColumn: '1 / -1', marginTop: '20px' }}>
                    <button
                      onClick={() => {
                        if (window.confirm('Restaurar todas as cores para o padrão?')) {
                          setFlow({
                            ...flow,
                            theme: {
                              primaryColor: "#3498db",
                              primaryColorHover: null,
                              secondaryColor: "#ecf0f1",
                              secondaryColorHover: null,
                              pageBackground: "#f5f7fa",
                              cardBackground: "#ffffff",
                              inputBackground: "#ffffff",
                              textPrimary: "#333333",
                              textSecondary: "#666666",
                              textOnPrimary: "#ffffff",
                              textOnSecondary: "#333333",
                              borderColor: "#dddddd",
                              borderRadius: "8px",
                              errorColor: "#e74c3c",
                              successColor: "#27ae60",
                              warningColor: "#f39c12",
                              infoColor: "#3498db",
                              buttonStyle: "rounded",
                              buttonPadding: "12px 24px",
                              buttonFontWeight: "600",
                              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
                              fontSize: "14px",
                              headingFontFamily: null,
                              headingFontWeight: "600",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                              boxShadowHover: "0 4px 12px rgba(0,0,0,0.1)",
                              transitionDuration: "0.2s",
                              progressBarColor: null,
                              progressBarBackground: "#e0e0e0",
                              logoBackground: "transparent",
                              logoPadding: "0",
                              logoBorderRadius: "0"
                            }
                          });
                        }
                      }}
                      className="btn btn-secondary"
                    >
                      <RefreshCw size={16} />
                      Restaurar Padrão
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Área Central - Editor de Campos */}
        <div className="builder-main">
          {selectedStep ? (
            <>
              <div className="step-editor">
                <div className="step-editor-header">
                  <h2 translate="no">
                    {flow.formConfig.steps.find(s => s.id === selectedStep)?.title || 'Etapa'}
                  </h2>
                  <p translate="no">
                    {flow.formConfig.steps.find(s => s.id === selectedStep)?.description}
                  </p>
                </div>

                <div className="fields-container">
                  {flow.formConfig.steps.find(s => s.id === selectedStep)?.fields
                    .sort((a, b) => a.order - b.order)
                    .map((field, index) => (
                      <div
                        key={field.id}
                        className={`field-item ${selectedField === field.id ? 'selected' : ''}`}
                        onClick={() => setSelectedField(field.id)}
                      >
                        <div className="field-header">
                          <div className="field-info">
                            {(() => {
                              const fieldType = FIELD_TYPES.find(f => f.type === field.type);
                              const Icon = fieldType?.icon;
                              return Icon ? <Icon size={16} /> : null;
                            })()}
                            <span className="field-label" translate="no">{field.label || 'Sem título'}</span>
                            {field.required && <span className="required">*</span>}
                          </div>
                          <div className="field-actions">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                moveField(selectedStep, field.id, 'up');
                              }}
                              disabled={index === 0}
                              className="btn-icon small"
                            >
                              <ChevronUp size={14} />
                            </button>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                moveField(selectedStep, field.id, 'down');
                              }}
                              disabled={index === flow.formConfig.steps.find(s => s.id === selectedStep).fields.length - 1}
                              className="btn-icon small"
                            >
                              <ChevronDown size={14} />
                            </button>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                deleteField(selectedStep, field.id);
                              }}
                              className="btn-icon small danger"
                            >
                              <Trash2 size={14} />
                            </button>
                          </div>
                        </div>

                        {/* Preview do campo */}
                        <div className="field-preview">
                          {field.type === 'info' && (
                            <div className="info-preview" translate="no">
                              {field.description}
                            </div>
                          )}
                          {field.type === 'section' && (
                            <div className="section-preview">
                              <hr />
                            </div>
                          )}
                          {(field.type === 'text' || field.type === 'email' || field.type === 'phone' || field.type === 'number') && (
                            <input
                              type={field.type}
                              placeholder={field.placeholder}
                              disabled
                              className="field-input-preview"
                            />
                          )}
                          {field.type === 'textarea' && (
                            <textarea
                              placeholder={field.placeholder}
                              disabled
                              rows={2}
                              className="field-input-preview"
                            />
                          )}
                          {field.type === 'select' && (
                            <select disabled className="field-input-preview">
                              <option>{field.placeholder || 'Selecione...'}</option>
                              {field.options?.map((opt, i) => (
                                <option key={i} translate="no">{opt.label}</option>
                              ))}
                            </select>
                          )}
                          {(field.type === 'radio' || field.type === 'checkbox') && (
                            <div className="options-preview">
                              {field.options?.slice(0, 2).map((opt, i) => (
                                <label key={i} className="option-preview">
                                  <input
                                    type={field.type}
                                    name={field.id}
                                    disabled
                                  />
                                  <span translate="no">{opt.label}</span>
                                </label>
                              ))}
                              {field.options?.length > 2 && (
                                <span className="more-options">+{field.options.length - 2} mais</span>
                              )}
                            </div>
                          )}
                          {field.type === 'button' && (
                            <div className="buttons-preview">
                              {field.options?.slice(0, 2).map((opt, i) => (
                                <button key={i} disabled className="btn-preview">
                                  {opt.icon && renderIcon(opt.icon, 16)}
                                  <span translate="no">{opt.label}</span>
                                </button>
                              ))}
                            </div>
                          )}
                          {field.type === 'date' && (
                            <input
                              type="date"
                              disabled
                              className="field-input-preview"
                            />
                          )}
                        </div>

                        {field.conditional?.show && (
                          <div className="conditional-badge">
                            <Zap size={12} />
                            Condicional
                          </div>
                        )}
                      </div>
                    ))}
                </div>

                <div className="add-field-section">
                  <h4>Adicionar Campo</h4>
                  <div className="field-types-grid">
                    {FIELD_TYPES.map(fieldType => (
                      <button
                        key={fieldType.type}
                        onClick={() => addField(selectedStep, fieldType.type)}
                        className="field-type-btn"
                        title={fieldType.description}
                      >
                        {(() => {
                          const Icon = fieldType.icon;
                          return <Icon size={20} />;
                        })()}
                        <span>{fieldType.label}</span>
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="no-step-selected">
              <Layout size={48} />
              <h3>Selecione uma etapa</h3>
              <p>Escolha uma etapa na barra lateral para começar a editar</p>
              <button onClick={addStep} className="btn btn-primary">
                <Plus size={20} />
                Criar primeira etapa
              </button>
            </div>
          )}
        </div>

        {/* Sidebar Direita - Propriedades do Campo */}
        {selectedField && (
          <div className="builder-sidebar-right">
            <div className="sidebar-header">
              <h3>Propriedades do Campo</h3>
              <button
                onClick={() => setSelectedField(null)}
                className="btn-icon"
              >
                <X size={20} />
              </button>
            </div>

            {(() => {
              const step = flow.formConfig.steps.find(s => s.id === selectedStep);
              const field = step?.fields.find(f => f.id === selectedField);
              if (!field) return null;

              return (
                <div className="field-properties">
                  <div className="form-group">
                    <label>Tipo de Campo</label>
                    <div className="field-type-display">
                      {(() => {
                        const fieldType = FIELD_TYPES.find(f => f.type === field.type);
                        const Icon = fieldType?.icon;
                        return (
                          <>
                            {Icon && <Icon size={16} />}
                            <span>{fieldType?.label}</span>
                          </>
                        );
                      })()}
                    </div>
                  </div>

                  {field.type !== 'section' && (
                    <div className="form-group">
                      <label>Rótulo</label>
                      <input
                        type="text"
                        value={field.label || ''}
                        onChange={(e) => updateField(selectedStep, selectedField, { label: e.target.value })}
                        placeholder="Texto do campo"
                      />
                    </div>
                  )}

                  {['text', 'textarea', 'email', 'phone', 'number', 'select'].includes(field.type) && (
                    <div className="form-group">
                      <label>Placeholder</label>
                      <input
                        type="text"
                        value={field.placeholder || ''}
                        onChange={(e) => updateField(selectedStep, selectedField, { placeholder: e.target.value })}
                        placeholder="Texto de exemplo"
                      />
                    </div>
                  )}

                  {field.type !== 'section' && (
                    <div className="form-group">
                      <label>Descrição</label>
                      <textarea
                        value={field.description || ''}
                        onChange={(e) => updateField(selectedStep, selectedField, { description: e.target.value })}
                        placeholder="Texto de ajuda"
                        rows={2}
                      />
                    </div>
                  )}

                  {field.type === 'info' && (
                    <div className="form-group">
                      <label>Ícone</label>
                      <div className="icon-selector">
                        <button
                          type="button"
                          className="icon-selector-trigger"
                          onClick={() => setShowIconPicker(showIconPicker === `field-${field.id}` ? null : `field-${field.id}`)}
                        >
                          {field.icon ? (
                            <>
                              {renderIcon(field.icon, 16)}
                              <span>{AVAILABLE_ICONS.find(i => i.value === field.icon)?.label}</span>
                            </>
                          ) : (
                            <span>Selecione um ícone</span>
                          )}
                          <ChevronDown size={16} />
                        </button>
                        
                        {showIconPicker === `field-${field.id}` && (
                          <div className="icon-picker-dropdown">
                            <div className="icon-picker-search">
                              <input
                                type="text"
                                placeholder="Buscar ícone..."
                                value={iconSearch}
                                onChange={(e) => setIconSearch(e.target.value)}
                              />
                            </div>
                            <div className="icon-picker-grid">
                              {AVAILABLE_ICONS
                                .filter(icon => 
                                  !iconSearch || 
                                  icon.label.toLowerCase().includes(iconSearch.toLowerCase()) ||
                                  icon.category.toLowerCase().includes(iconSearch.toLowerCase())
                                )
                                .map(icon => (
                                  <button
                                    key={icon.value}
                                    type="button"
                                    className={`icon-picker-item ${field.icon === icon.value ? 'selected' : ''}`}
                                    onClick={() => {
                                      updateField(selectedStep, selectedField, { icon: icon.value });
                                      setShowIconPicker(null);
                                      setIconSearch('');
                                    }}
                                    title={icon.label}
                                  >
                                    {renderIcon(icon.value, 20)}
                                  </button>
                                ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {field.type !== 'section' && field.type !== 'info' && (
                    <div className="form-group">
                      <label>
                        <input
                          type="checkbox"
                          checked={field.required || false}
                          onChange={(e) => updateField(selectedStep, selectedField, { required: e.target.checked })}
                        />
                        Campo obrigatório
                      </label>
                    </div>
                  )}

                  {/* Opções para select, radio, checkbox, button */}
                  {['select', 'radio', 'checkbox', 'button'].includes(field.type) && (
                    <div className="options-section">
                      <div className="section-header">
                        <h4>Opções</h4>
                        <button
                          onClick={() => addOption(selectedStep, selectedField)}
                          className="btn-icon small"
                        >
                          <Plus size={14} />
                        </button>
                      </div>

                      <div className="options-list">
                        {field.options?.map((option, index) => (
                          <div key={index} className="option-item">
                            <div className="option-fields">
                              <input
                                type="text"
                                value={option.label}
                                onChange={(e) => updateOption(selectedStep, selectedField, index, { label: e.target.value })}
                                placeholder="Texto"
                                className="option-label"
                              />
                              <input
                                type="text"
                                value={option.value}
                                onChange={(e) => updateOption(selectedStep, selectedField, index, { value: e.target.value })}
                                placeholder="Valor"
                                className="option-value"
                              />
                              {field.type === 'button' && (
                                <div className="icon-selector-compact">
                                  <button
                                    type="button"
                                    className="icon-selector-trigger compact"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setShowIconPicker(showIconPicker === `option-${field.id}-${index}` ? null : `option-${field.id}-${index}`);
                                    }}
                                    title="Selecionar ícone"
                                  >
                                    {option.icon ? renderIcon(option.icon, 16) : <Plus size={16} />}
                                  </button>
                                  
                                  {showIconPicker === `option-${field.id}-${index}` && (
                                    <div className="icon-picker-dropdown compact">
                                      <div className="icon-picker-grid">
                                        <button
                                          type="button"
                                          className="icon-picker-item"
                                          onClick={() => {
                                            updateOption(selectedStep, selectedField, index, { icon: '' });
                                            setShowIconPicker(null);
                                          }}
                                          title="Sem ícone"
                                        >
                                          <X size={16} />
                                        </button>
                                        {AVAILABLE_ICONS.map(icon => (
                                          <button
                                            key={icon.value}
                                            type="button"
                                            className={`icon-picker-item ${option.icon === icon.value ? 'selected' : ''}`}
                                            onClick={() => {
                                              updateOption(selectedStep, selectedField, index, { icon: icon.value });
                                              setShowIconPicker(null);
                                            }}
                                            title={icon.label}
                                          >
                                            {renderIcon(icon.value, 16)}
                                          </button>
                                        ))}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                              <button
                                onClick={() => removeOption(selectedStep, selectedField, index)}
                                className="btn-icon small danger"
                              >
                                <Trash2 size={14} />
                              </button>
                            </div>
                            {(field.type === 'radio' || field.type === 'button') && (
                              <input
                                type="text"
                                value={option.description || ''}
                                onChange={(e) => updateOption(selectedStep, selectedField, index, { description: e.target.value })}
                                placeholder="Descrição (opcional)"
                                className="option-description"
                              />
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Estilo */}
                  <div className="form-group">
                    <label>Largura</label>
                    <select
                      value={field.style?.width || 'full'}
                      onChange={(e) => updateField(selectedStep, selectedField, {
                        style: { ...field.style, width: e.target.value }
                      })}
                    >
                      <option value="full">Largura total</option>
                      <option value="half">Metade</option>
                      <option value="third">Um terço</option>
                      <option value="quarter">Um quarto</option>
                    </select>
                  </div>

                  {['button', 'radio', 'info'].includes(field.type) && (
                    <div className="form-group">
                      <label>Variante</label>
                      <select
                        value={field.style?.variant || 'default'}
                        onChange={(e) => updateField(selectedStep, selectedField, {
                          style: { ...field.style, variant: e.target.value }
                        })}
                      >
                        <option value="default">Padrão</option>
                        <option value="large">Grande</option>
                        <option value="card">Cartão</option>
                        <option value="inline">Em linha</option>
                      </select>
                    </div>
                  )}

                  {/* Condicional */}
                  <div className="conditional-section">
                    <h4>Lógica Condicional</h4>
                    <label>
                      <input
                        type="checkbox"
                        checked={field.conditional?.show || false}
                        onChange={(e) => updateField(selectedStep, selectedField, {
                          conditional: { ...field.conditional, show: e.target.checked }
                        })}
                      />
                      Mostrar condicionalmente
                    </label>

                    {field.conditional?.show && (
                      <>
                        <div className="form-group">
                          <label>Quando o campo</label>
                          <select
                            value={field.conditional.when || ''}
                            onChange={(e) => updateField(selectedStep, selectedField, {
                              conditional: { ...field.conditional, when: e.target.value }
                            })}
                          >
                            <option value="">Selecione um campo</option>
                            {step.fields
                              .filter(f => f.id !== selectedField && ['select', 'radio', 'checkbox', 'button'].includes(f.type))
                              .map(f => (
                                <option key={f.id} value={f.id}>{f.label}</option>
                              ))}
                          </select>
                        </div>

                        <div className="form-group">
                          <label>For igual a</label>
                          <input
                            type="text"
                            value={field.conditional.equals || ''}
                            onChange={(e) => updateField(selectedStep, selectedField, {
                              conditional: { ...field.conditional, equals: e.target.value }
                            })}
                            placeholder="Valor esperado"
                          />
                        </div>
                      </>
                    )}
                  </div>

                  {/* Validação */}
                  {['text', 'textarea', 'email', 'phone', 'number'].includes(field.type) && (
                    <div className="validation-section">
                      <h4>Validação</h4>

                      {field.type === 'text' || field.type === 'textarea' ? (
                        <>
                          <div className="form-group">
                            <label>Mínimo de caracteres</label>
                            <input
                              type="number"
                              value={field.validation?.minLength || ''}
                              onChange={(e) => updateField(selectedStep, selectedField, {
                                validation: { ...field.validation, minLength: parseInt(e.target.value) || undefined }
                              })}
                              min="0"
                            />
                          </div>
                          <div className="form-group">
                            <label>Máximo de caracteres</label>
                            <input
                              type="number"
                              value={field.validation?.maxLength || ''}
                              onChange={(e) => updateField(selectedStep, selectedField, {
                                validation: { ...field.validation, maxLength: parseInt(e.target.value) || undefined }
                              })}
                              min="0"
                            />
                          </div>
                        </>
                      ) : field.type === 'number' ? (
                        <>
                          <div className="form-group">
                            <label>Valor mínimo</label>
                            <input
                              type="number"
                              value={field.validation?.min || ''}
                              onChange={(e) => updateField(selectedStep, selectedField, {
                                validation: { ...field.validation, min: parseFloat(e.target.value) || undefined }
                              })}
                            />
                          </div>
                          <div className="form-group">
                            <label>Valor máximo</label>
                            <input
                              type="number"
                              value={field.validation?.max || ''}
                              onChange={(e) => updateField(selectedStep, selectedField, {
                                validation: { ...field.validation, max: parseFloat(e.target.value) || undefined }
                              })}
                            />
                          </div>
                        </>
                      ) : null}

                      <div className="form-group">
                        <label>Mensagem de erro personalizada</label>
                        <input
                          type="text"
                          value={field.validation?.customMessage || ''}
                          onChange={(e) => updateField(selectedStep, selectedField, {
                            validation: { ...field.validation, customMessage: e.target.value }
                          })}
                          placeholder="Ex: Por favor, insira um valor válido"
                        />
                      </div>
                    </div>
                  )}
                </div>
              );
            })()}
          </div>
        )}
      </div>
    </div>
  );
};

export default FlowBuilder;